import { usePersistentStore } from '~/stores/persistent'
import { emitDemoReferralTag } from '~/utils/clarity'

// Emits the Clarity custom tag for sessions that ENTERED through a demonstrator
// attribution link whose demonstrator the cart accepted. The marker is set
// server-side in init-auth.server.ts before the strip-redirect removes the
// param, because Clarity's tag only ever runs on the clean destination URL and
// so can never see it. AB#63131
//
// `dependsOn` is load-bearing. Reading the marker would work in any order:
// Pinia restores the SSR state before any application plugin runs. Clearing it
// would not. The cookie is deleted by the `$onAction` subscriber the persistent
// plugin registers, so a clear that ran before that subscriber existed would
// leave the cookie behind and the next load would tag the session again.
// `enforce: 'post'` is nuxt2's `auth.plugins` placement expressed in this
// repo's terms; it is not what orders this after persistence.
export default defineNuxtPlugin({
  name: 'clarity-demo-referral',
  enforce: 'post',
  dependsOn: ['persistent'],
  setup () {
    const persistentStore = usePersistentStore()
    emitDemoReferralTag(
      persistentStore.getPersistentValue('demoReferral'),
      // Persistence clears both legacy market-domain and Nuxt4 host-only scopes.
      () => persistentStore.updateValue('demoReferral', null)
    )
  }
})
